import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Person } from '../../shared/models';
import { PeopleService } from '../../shared/services';
@Component({
    templateUrl: './detail.component.html',
    standalone: false
})
export class PersonDetailPageComponent implements OnInit {
  public person: Person;
  public personId: string;

  constructor(
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private peopleService: PeopleService
  ) {}

  ngOnInit(): void {
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      let id = params['personId'];
      if (id == null) this.router.navigate(['inspectionbrowser/people']);

      this.personId = id;

      this.initData();
    });
  }

  public goToBack() {
    this.location.back();
  }

  initData(): void {
    this.peopleService.getPerson(this.personId).subscribe((data) => {
      this.person = data;
    });
  }
}
